import React from 'react';
import styles from './HomeFooter.module.css';
import listViewIcon from '../../../assets/icons/listview.svg';
import stackViewIcon from '../../../assets/icons/stackview.svg';
import connectionsIcon from '../../../assets/icons/connectionsView.svg';
import PreviousCardIcon from '../../../assets/icons/previous-card.svg';
import { useHomeFooter, FooterButtonPosition } from '../context/HomeFooterContext';
import { HomeSurface } from './HomeView';
import { getNextSurface } from './getNextSurface';

interface HomeFooterProps {
    enablePrevButton: boolean;
    onPrevCard: () => void;
    onSwitchView: () => void;
    currentSurface: HomeSurface;
    loading: boolean;
}

export const HomeFooter: React.FC<HomeFooterProps> = ({
    enablePrevButton,
    onPrevCard,
    onSwitchView,
    currentSurface,
    loading,
}) => {
    const { footerButtons } = useHomeFooter();

    const renderNextSurfaceIcon = () => {
        switch (getNextSurface(currentSurface)) {
            case HomeSurface.DIGEST_LIST:
                return (
                    <img src={listViewIcon} alt="List View" />
                );
            case HomeSurface.DIGEST:
                return (
                    <img src={stackViewIcon} alt="Stack View" />
                );
            case HomeSurface.CONNECTIONS:
                return (
                    <img src={connectionsIcon} alt="Connection View" />
                );
        }
    };

    return (
        <div className={styles.footerContainer}>
            {footerButtons[FooterButtonPosition.LEFT] ? (
                <div className={styles.actionButton}>{footerButtons[FooterButtonPosition.LEFT]}</div>
            ) : (
                <button onClick={onPrevCard} className={styles.actionButton} disabled={loading || !enablePrevButton}>
                    <img src={PreviousCardIcon} alt="Previous" />
                </button>
            )}

            {footerButtons[FooterButtonPosition.MIDDLE] && (
                <div className={styles.actionButton}>{footerButtons[FooterButtonPosition.MIDDLE]}</div>
            )}

            {footerButtons[FooterButtonPosition.RIGHT] ? (
                <div className={styles.actionButton}>{footerButtons[FooterButtonPosition.RIGHT]}</div>
            ) : (
                <button onClick={onSwitchView} className={styles.actionButton} disabled={loading}>
                    {renderNextSurfaceIcon()}
                </button>
            )}
        </div>
    );
};
